<template>
	<div class="container pt-5 pb-5">
		<h5 class="c-main__title mb-4">List categories</h5>
    <category v-for="category in categories"
              :key="category['.key']"
              :categoryName="category.name"
              :categoryKey="category['.key']"
              :categoryBackground="category.backgroundName"
              :categorySlug="category.slug" />
	</div>
</template>

<script>
  import { categories } from '../../firebase'
  import category from './CategoryTable'

  export default {
    components: {
      category
    },
    data() {
      return {}
    },
    firestore() {
      return {
        categories: categories.orderBy('priority')
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  .btn-add-subcategory{
    background-color: transparent !important;
    border: 2px solid #ddd;
    border-style: dashed;
    color: #ddd - 50%;
    &:focus{
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Categories.vue